// util.js
export const utility = {
  successMsg(msg) {
    alert(`✅ Success:\n${msg}`);
  },
  SuccessMsg(msg) {
    this.successMsg(msg);
  },

  warningMsg(msg) {
    alert(`⚠️ Warning:\n${msg}`);
  },
  WarningMsg(msg) {
    this.warningMsg(msg);
  },

  errorMsg(msg) {
    alert(`❌ Error:\n${msg}`);
  },
  ErrorMsg(msg) {
    this.errorMsg(msg);
  },

  sanitizeFilename(filename) {
    if (!filename) return "File";
    const invalidChars = /[<>:"/\\|?*\x00-\x1F]/g;
    return filename.replace(invalidChars, "_");
  },
  SanitizeFilename(filename) {
    return this.sanitizeFilename(filename);
  },

  async reUploadMessage(msg) {
    return confirm(`⚠️ ${msg}\n\nDo you want to re-upload?`);
  },

  async ReUploadMessage(msg) {
    return new Promise((resolve) => {
      const dialog = document.getElementById("confirmDialog");
      const messageEl = document.getElementById("confirmMessage");
      const yesBtn = document.getElementById("confirmYes");
      const noBtn = document.getElementById("confirmNo");
      
      messageEl.textContent = `${msg}`;
      dialog.style.display = "block";

      const onKeyDown = (e) => {
        if (e.key === "Escape") {
          cleanup();
          resolve(false);
        }
      };

      document.addEventListener("keydown", onKeyDown);
      
      const cleanup = () => {
        dialog.style.display = "none";
        yesBtn.onclick = null;
        noBtn.onclick = null;
        document.removeEventListener("keydown", onKeyDown);
      };
      
      yesBtn.onclick = () => {
        cleanup();
        resolve(true);
      };
      
      noBtn.onclick = () => {
        cleanup();
        resolve(false);
      };
    });
  },

  // Get sender email using Office.js
  async getSenderEmail() {
    try {
      const item = Office.context.mailbox.item;
      if (item && item.from && item.from.emailAddress) {
        return item.from.emailAddress;
      }
      return "";
    } catch (ex) {
      console.error("Error getting sender:", ex);
      return "";
    }
  },

  getSenderSmtpAddress(sender) {
    if (!sender) return "";
    return sender.emailAddress || sender.address || "";
  },
  GetSenderSmtpAddress(sender) {
    return this.getSenderSmtpAddress(sender);
  },

  async getBodyAsText(item) {
    return new Promise((resolve) => {
      if (item && item.body && item.body.getAsync) {
        item.body.getAsync(Office.CoercionType.Text, (result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve(result.value);
          } else {
            resolve("");
          }
        });
      } else {
        resolve("");
      }
    });
  },
  GetBodyAsText(item) {
    return this.getBodyAsText(item);
  },

  // Get all recipients (TO, CC, BCC)
  async getAllRecipients() {
    try {
      const item = Office.context.mailbox.item;
      const recipients = [];

      ["to", "cc", "bcc"].forEach((type) => {
        const list = item[type];
        if (Array.isArray(list)) {
          list.forEach((r) => recipients.push(r));
        }
      });

      return recipients;
    } catch (ex) {
      console.error("Error getting recipients:", ex);
      return [];
    }
  },

  getRecipients(recipients, index) {
    if (!recipients || !Array.isArray(recipients)) return "";

    const smtpAddresses = recipients.map((r) => {
      // Handle Graph / Office.js structure properly
      if (r.emailAddress && typeof r.emailAddress === "object") {
        return r.emailAddress.address || "";
      }
      return r.emailAddress || r.address || "";
    });

    return index >= 0 && index < smtpAddresses.length ? smtpAddresses[index] : "";
  },
  GetRecipients(recipients, index) {
    return this.getRecipients(recipients, index);
  },

  getSmtpAddresses(recipients) {
    if (!recipients || !Array.isArray(recipients)) return [];
    return recipients.map((r) => r.emailAddress || r.address || "");
  },
  GetSmtpAddresses(recipients) {
    return this.getSmtpAddresses(recipients);
  },

  getMailUniqueKey(mail) {
    if (!mail) return "";

    // 1. Priority: Internet Message ID (Matches C# MAPI 0x1035001F)
    // In Office.js/Graph, this is internetMessageId.
    // If it exists, C# returns ONLY this.
    if (mail.internetMessageId && mail.internetMessageId.trim() !== "") {
      return mail.internetMessageId;
    }

    // 2. Fallback Construction
    // C# uses: $"{sender}, {recipients}, {subject},{EntryID}"

    const sender = this.getSenderSmtpAddress(mail.from);

    // Ensure this helper matches the C# GetRecipients logic exactly
    const allRecipients = [];
    if (mail.to) allRecipients.push(...mail.to);
    if (mail.cc) allRecipients.push(...mail.cc);
    if (mail.bcc) allRecipients.push(...mail.bcc);
    const recipients = this.getRecipients(allRecipients, 0);

    const subject = (mail.subject || "").replace(/'/g, "\\'");

    // C# uses EntryID. In JS (Office.js/Graph), 'id' is the equivalent.
    const entryId = mail.id || "";

    // Note the exact spacing: comma-space after sender, recipients, and subject.
    // But NO space between the last comma and entryId to match the C# string interpolation.
    return `${sender}, ${recipients}, ${subject},${entryId}`;
  },
  GetMailUniqueKey(mail) {
    return this.getMailUniqueKey(mail);
  },

  async getInternetMessageId(item) {
    try {
      return new Promise((resolve, reject) => {
        Office.context.mailbox.getCallbackTokenAsync({ isRest: true }, function (asyncResult) {
          if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
            const ewsId = item.itemId;
            resolve(ewsId); // fallback, since REST/Graph needs token
          } else {
            reject(asyncResult.error);
          }
        });
      });
    } catch (ex) {
      console.error("Error getting InternetMessageId:", ex);
      return "";
    }
  },
};
